/*=========================================================================================
  File Name: moduleAccountsMutations.js
  Description: Accounts Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    SET_ACCOUNTS(state, accounts) {
        state.accounts = {};
        for (const [key, value] of Object.entries(accounts)) {
            if (value.length > 0) {
                state.accounts[key] = [];
                for (let i = 0; i < value.length; i++) {
                    let contact = {
                        id: value[i].id,
                        accountType: value[i].roles[0],
                        username: value[i].userName,
                        institution: value[i].institution,
                        date: value[i].createDate,
                        email: value[i].email,
                        firstName: value[i].firstName,
                        lastName: value[i].lastName,
                        name: value[i].firstName + " " + value[i].lastName
                    };
                    if (!value[i].disabled) {state.accounts[key].push(contact)}
                }
            }
        }
    },

    SET_ACCOUNT(state, account) {
        state.account = account;
    },

    SET_ACCOUNTS_META(state, accounts_meta) {
        state.accounts_meta = accounts_meta;
    },

    SET_ROLES(state, roles) {
        state.roles = roles;
        state.roleIDs = [];

        for (let i = 0; i < roles.length; i++) {
            if (roles[i].name === "phthisiologist" || roles[i].name === "epidemiologist") {
                state.roleIDs.push(roles[i].id);
            }
        }
    },

}
